import { Link } from '@tanstack/react-router';
import type { AnchorHTMLAttributes } from 'react';
import { parseSearch } from '../urlDates';
import { useViewAsHref } from './viewAs';

/**
 * The router's Link with an `href`, for design-system components that take `as` (a
 * SidebarItem). Link marks itself current only on its exact path, so the component's own
 * `aria-current` decides the rest (a drill-in under /reps keeps My reps current). A query
 * in the href (People's filters) becomes the link's search. Under /view-as/$userId an
 * in-app href keeps that prefix.
 */
export function RouterLink({
  href,
  ...rest
}: Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'target'> & { href: string }) {
  const to = useViewAsHref(href);
  const at = to.indexOf('?');
  if (at < 0) return <Link to={to} activeOptions={{ exact: true }} {...rest} />;
  return (
    <Link
      to={to.slice(0, at)}
      search={parseSearch(to.slice(at))}
      activeOptions={{ exact: true }}
      {...rest}
    />
  );
}
